import { render } from "./BlogHome.vue?vue&type=template&id=64797e02&scoped=true"
import script from "./BlogHome.vue?vue&type=script&lang=js"
export * from "./BlogHome.vue?vue&type=script&lang=js"

import "./BlogHome.vue?vue&type=style&index=0&id=64797e02&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe/Safe_Sites_Modifs/SAFE_MED/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64797e02"]])

export default __exports__